// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/monitor.js';

import { paths } from '../generated/monitor';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('monitor', Original, paths);
